import { gql } from "@apollo/client"

const GET_SITE_DATA_STAFF_XLS_DOWNLOAD_LINK = gql`
  query GetStaffXlsDownload($clientId: ID!) {
    dataStaffXlsDownload(client_id: $clientId) {
      filename
      type
      url
      queued
    }
  }
`

export { GET_SITE_DATA_STAFF_XLS_DOWNLOAD_LINK }
